import styled from "styled-components";
import { windowWidth } from "@styles/global";

const OptionContainer = styled.div`
  padding-top: 15px;

  @media (min-width: ${windowWidth.tablet}) {
    width: 33%;
  }
`;

const DescriptionText = styled.p`
  color: #666666;
  font-size: 13px;
`;

const PasswordContainer = styled.div`
  div {
    width: 95% !important;
  }
`;

export { OptionContainer, DescriptionText, PasswordContainer };